export const EXECUTION_ACTIONS = {
  view: 'view',
  download_input: 'download_input',
  download_report: 'download_report',
  cancel: 'cancel',
} as const;

export const DEFAULT_PAGINATION_SETTINGS = {
  page: 1,
  pageSize: 25,
  ordering: '-created',
};
